export const BANKRUPYCY_CHAPTER = {
  CHAPTER_7: 'Chapter 7',
  CHAPTER_11: 'Chapter 11',
  CHAPTER_12: 'Chapter 12',
  CHAPTER_13: 'Chapter 13',
} as const;
